import { Outlet } from "react-router-dom";
import DashboardHeader from "./components/Dashboard";

const Layout = () => {
  return (
    <>
      <DashboardHeader /> {/* ✅ Common header for all pages */}
      <div className="content">
        <Outlet /> {/* ✅ This renders HealthProductMaster or Agency */}
      </div>
    </>
  );
};

export default Layout;